import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { memo, useEffect, useMemo, useState } from "react";
import ReactModal from "react-modal";

import { ReactComponent as AlbumIcon } from "assets/icons/album.svg";
import { ReactComponent as ChevronLeftCircleIcon } from "assets/icons/chevron-left-circle-alt.svg";
import { ReactComponent as ChevronRightCircleIcon } from "assets/icons/chevron-right-circle-alt.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { File } from "types/types";
import { fileUrl } from "utils/utils";

const ImagePreview = ({
  files,
  file,
  isTransfer,
}: {
  files: File[];
  file: File;
  isTransfer?: boolean;
}) => {
  const modal = useModal();
  const [loading, setLoading] = useState(true);

  const items = useMemo(() => files.filter((f) => f.upldfilename), [files]);
  const [index, setIndex] = useState(files.findIndex((f) => f.id === file.id));

  useEffect(() => {
    setLoading(true);
  }, [index]);

  const closeModal = () => {
    modal.hide();
    modal.reject();
  };

  const onPrev = () => {
    if (index > 0) {
      setIndex((i) => i - 1);
    }
  };

  const onNext = () => {
    if (index < items.length - 1) {
      setIndex((i) => i + 1);
    }
  };

  return (
    <ReactModal
      overlayClassName="overflow-auto flex fixed size-full top-0 left-0 z-30"
      className="bg-[rgba(0,0,0,0.2)] min-w-[1280px] min-h-[720px] flex justify-center items-center size-full outline-none"
      isOpen={modal.visible}
      onRequestClose={closeModal}
      onAfterClose={() => {
        modal.remove();
      }}
    >
      <main className="bg-white flex flex-col h-[41.563rem] w-[50rem] rounded-md">
        <header className="flex justify-end w-full relative p-[1.875rem]">
          <h2 className="absolute flex items-center justify-center text-center inset-0 justify-self-center self-center font-bold text-24 ">
            사진 미리보기
          </h2>
          <button className="relative z-10" type="button" onClick={closeModal}>
            <CloseIcon className="size-[2.25rem]" />
          </button>
        </header>
        <section className="relative flex-1 overflow-hidden flex items-center">
          <div className="size-full absolute z-0 bg-gray flex items-center justify-center">
            <div className="inline-flex">
              {loading ? (
                <div className="size-15 inline-block after:block after:w-12 after:h-12 after:m-2 after:rounded-full after:border-solid after:border-[4px] after:border-[rgba(0,0,0,0.3)_transparent_rgba(0,0,0,0.3)_transparent] lds-dual-ring"></div>
              ) : (
                <AlbumIcon />
              )}
            </div>
          </div>
          <button
            disabled={!index}
            type="button"
            onClick={onPrev}
            className="absolute left-5 z-10"
          >
            <ChevronLeftCircleIcon className="size-[2.813rem]" />
          </button>
          <img
            className="relative size-full object-contain"
            key={index}
            src={
              isTransfer
                ? files[index].filepath
                : `${fileUrl}=${files[index].filename}&uploadFileName=${encodeURI(encodeURI(files[index].upldfilename))}&filePath=${files[index].filepath}&disp=attachment`
            }
            alt={files[index].filename}
            loading="lazy"
            onLoad={() => setLoading(false)}
            onError={() => setLoading(false)}
          />
          <button
            disabled={index === items.length - 1}
            type="button"
            onClick={onNext}
            className="absolute right-5 z-10"
          >
            <ChevronRightCircleIcon className="size-[2.813rem]" />
          </button>
        </section>
      </main>
    </ReactModal>
  );
};

const ImagePreviewModal = NiceModal.create(memo(ImagePreview));
ImagePreviewModal.displayName = "ImagePreviewModal";

export default ImagePreviewModal;
